// components/FollowCommentModal/index.tsx
// フォローコメントの追加・編集用モーダル（PC版 followComment.js 相当の入力ダイアログ）
//
// テキストのみを入力するシンプルなモーダル。保存押下時は呼び出し元へテキストを渡すのみで、
// 実際の保存API呼び出し・通知先選択への連携はホスト側（useFollowComments）が担当する。

import React, { useState, useEffect } from 'react';
import { Modal, Button, Input } from 'antd';
import { MODAL_Z } from '../../utils/modalZIndex';

export interface FollowCommentModalProps {
  /** モーダルの表示状態 */
  open: boolean;
  /** 'add'=新規登録 / 'edit'=編集 */
  mode: 'add' | 'edit';
  /** 編集時の初期テキスト */
  initialText?: string;
  /** キャンセル時のコールバック */
  onCancel: () => void;
  /** 保存ボタン押下時のコールバック（バリデーション済みテキストを渡す） */
  onSave: (text: string) => void;
  /** モーダルの zIndex */
  zIndex?: number;
}

const FollowCommentModal: React.FC<FollowCommentModalProps> = ({
  open,
  mode,
  initialText = '',
  onCancel,
  onSave,
  zIndex = MODAL_Z.L2,
}) => {
  const [text, setText] = useState<string>('');
  const [error, setError] = useState<string>('');

  useEffect(() => {
    if (open) {
      setText(initialText);
      setError('');
    }
  }, [open, initialText]);

  const handleSave = () => {
    if (text.trim().length === 0) {
      setError('コメントを入力してください');
      return;
    }
    onSave(text);
  };

  return (
    <>
      {open && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: zIndex - 1 }} />
      )}
      <Modal
        title={mode === 'add' ? 'コメントを追加' : 'コメントを編集'}
        open={open}
        onCancel={onCancel}
        centered
        mask={false}
        maskClosable={false}
        zIndex={zIndex}
        footer={
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <Button onClick={onCancel}>キャンセル</Button>
            <Button type="primary" onClick={handleSave}>保存</Button>
          </div>
        }
      >
        <Input.TextArea
          rows={4}
          placeholder="コメントを入力"
          value={text}
          onChange={e => { setText(e.target.value); setError(''); }}
          status={error ? 'error' : undefined}
        />
        {error && (
          <p style={{ color: '#ff4d4f', fontSize: 12, marginTop: 4, marginBottom: 0 }}>{error}</p>
        )}
      </Modal>
    </>
  );
};

export default FollowCommentModal;
